export const FETCH_TRIATHLON_TYPES = 'FETCH_TRIATHLON_TYPES';
export const FETCH_TRIATHLON_TYPES_FETCHING = 'FETCH_TRIATHLON_TYPES_FETCHING';
export const FETCH_TRIATHLON_TYPES_SUCCESS = 'FETCH_TRIATHLON_TYPES_SUCCESS';
export const FETCH_TRIATHLON_TYPES_FAIL = 'FETCH_TRIATHLON_TYPES_FAIL';

export function fetchTriathlonTypes(evictCache) {
    return {
        type: FETCH_TRIATHLON_TYPES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}
